export default __webpack_public_path__ + "static/media/Reporting.5e47b266.svg";